"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledWizardViewAttemptModal = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var DpModal_1 = require("../Modal/DpModal");
exports.StyledWizardViewAttemptModal = (0, styled_components_1.default)(DpModal_1.DpModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-header {\n    border-bottom: 0;\n\n    h1 {\n      color: ", ";\n      font-size: ", ";\n\n      span {\n        color: ", ";\n        font-size: ", ";\n        margin-left: ", ";\n        font-weight: normal;\n      }\n    }\n  }\n\n  .modal-container {\n    border: 1px solid ", ";\n    border-radius: ", ";\n\n    .header {\n      border-bottom: 1px solid ", ";\n\n      .question-info {\n        display: flex;\n        justify-content: space-between;\n        padding: ", ";\n\n        span.title {\n          font-weight: bold;\n          font-size: ", ";\n          color: ", ";\n        }\n\n        span.response-info {\n          ", ";\n          border-left: 1px solid ", ";\n          font-weight: bold;\n          font-size: ", ";\n          color: ", ";\n          padding: ", ";\n        }\n      }\n    }\n  }\n\n  .attempt-container {\n    display: flex;\n\n    .response-container {\n      width: 80%;\n      overflow: hidden;\n    }\n  }\n\n  .feedback-container {\n    padding: ", ";\n    width: 25%;\n    height: 100%;\n\n    .feedback-title {\n      ", ";\n      margin-bottom: ", ";\n\n      i {\n        font-size: ", ";\n        margin-right: ", ";\n        color: ", ";\n\n        &.active {\n          color: ", ";\n        }\n      }\n\n      h4 {\n        font-size: ", ";\n        color: ", ";\n        margin: 0;\n      }\n    }\n\n    .feedback-content {\n      color: ", ";\n      font-size: ", ";\n      border: 1px solid ", ";\n      border-radius: ", ";\n      min-height: 200px;\n      padding: ", ";\n      word-wrap: break-word;\n    }\n  }\n\n  /** Learnosity */\n  .top-right-wrapper {\n    display: flex;\n    justify-content: flex-end;\n\n    button.lrn_btn_notepad {\n      background: transparent !important;\n      display: flex !important;\n      justify-content: center;\n      align-items: center;\n\n      &:focus {\n        border: 0;\n        box-shadow: none !important;\n      }\n\n      .btn-label {\n        color: ", ";\n        text-transform: capitalize;\n        font-size: ", ";\n      }\n\n      .lrn_svg_icon {\n        color: ", ";\n        top: 0 !important;\n        left: 0 !important;\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  .progress {\n    display: none;\n  }\n\n  .lrn.lrn-assess .lrn-bottom-right-region.lrn-align-top.lrn-region {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .item-count .current-item-pos {\n    font-size: ", ";\n    color: ", ";\n    margin-left: ", ";\n  }\n\n  .bottom-wrapper,\n  .bottom-right-wrapper {\n    display: flex;\n    justify-content: space-between;\n    padding-top: ", ";\n\n    .item-next {\n      margin-left: auto !important;\n      letter-spacing: 2px;\n    }\n  }\n"], ["\n  .modal-header {\n    border-bottom: 0;\n\n    h1 {\n      color: ", ";\n      font-size: ", ";\n\n      span {\n        color: ", ";\n        font-size: ", ";\n        margin-left: ", ";\n        font-weight: normal;\n      }\n    }\n  }\n\n  .modal-container {\n    border: 1px solid ", ";\n    border-radius: ", ";\n\n    .header {\n      border-bottom: 1px solid ", ";\n\n      .question-info {\n        display: flex;\n        justify-content: space-between;\n        padding: ", ";\n\n        span.title {\n          font-weight: bold;\n          font-size: ", ";\n          color: ", ";\n        }\n\n        span.response-info {\n          ", ";\n          border-left: 1px solid ", ";\n          font-weight: bold;\n          font-size: ", ";\n          color: ", ";\n          padding: ", ";\n        }\n      }\n    }\n  }\n\n  .attempt-container {\n    display: flex;\n\n    .response-container {\n      width: 80%;\n      overflow: hidden;\n    }\n  }\n\n  .feedback-container {\n    padding: ", ";\n    width: 25%;\n    height: 100%;\n\n    .feedback-title {\n      ", ";\n      margin-bottom: ", ";\n\n      i {\n        font-size: ", ";\n        margin-right: ", ";\n        color: ", ";\n\n        &.active {\n          color: ", ";\n        }\n      }\n\n      h4 {\n        font-size: ", ";\n        color: ", ";\n        margin: 0;\n      }\n    }\n\n    .feedback-content {\n      color: ", ";\n      font-size: ", ";\n      border: 1px solid ", ";\n      border-radius: ", ";\n      min-height: 200px;\n      padding: ", ";\n      word-wrap: break-word;\n    }\n  }\n\n  /** Learnosity */\n  .top-right-wrapper {\n    display: flex;\n    justify-content: flex-end;\n\n    button.lrn_btn_notepad {\n      background: transparent !important;\n      display: flex !important;\n      justify-content: center;\n      align-items: center;\n\n      &:focus {\n        border: 0;\n        box-shadow: none !important;\n      }\n\n      .btn-label {\n        color: ", ";\n        text-transform: capitalize;\n        font-size: ", ";\n      }\n\n      .lrn_svg_icon {\n        color: ", ";\n        top: 0 !important;\n        left: 0 !important;\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n\n  .progress {\n    display: none;\n  }\n\n  .lrn.lrn-assess .lrn-bottom-right-region.lrn-align-top.lrn-region {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .item-count .current-item-pos {\n    font-size: ", ";\n    color: ", ";\n    margin-left: ", ";\n  }\n\n  .bottom-wrapper,\n  .bottom-right-wrapper {\n    display: flex;\n    justify-content: space-between;\n    padding-top: ", ";\n\n    .item-next {\n      margin-left: auto !important;\n      letter-spacing: 2px;\n    }\n  }\n"])), function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.lg;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.slateGrey;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.lg;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x3, " ").concat(Spacing.x4);
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Backgrounds.subtle;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "0 0 0 ".concat(Spacing.x3);
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x3, " ").concat(Spacing.x3, " 0 0");
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xl;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Brand.inactive;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.active;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.primary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Borders.hint;
}, function (_a) {
    var Dimensions = _a.theme.Dimensions;
    return Dimensions.Borders.Radiuses.medium;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.active;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.dark;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x7;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
});
var templateObject_1;
